<template>
  <div>
    <common :dataSource='dataSource' :type="3"></common>
  </div>
</template>
<script>
import common from './common.vue'
export default {
  components: {
    common
  },
  data() {
    return {
      dataSource: [
        [
          // {
          //   type: 9,
          //   title: '这些题目是否有趣？话题、感兴趣吗，题目难吗，好解决吗，这些题在以前测评中常见吗新颖，是方式、问法，还是什么？'
          // },
          // {
          //   type: 7,
          //   headline: '你认为是哪个学科的题目？'
          // },
          {
            type: 3,
            title: '请按照你的真实感受，做出判断并选择对应的选项。'
          },
          {
            type: 2,
            headline: '1.你对该任务的场景熟悉吗？',
            value: [
              '很不熟悉', '不熟悉', '一般', '熟悉', '很熟悉'
            ]
          },
          {
            type: 2,
            headline: '2.你对这些题目感兴趣吗？',
            value: [
              '很不感兴趣', '不感兴趣', '一般', '感兴趣', '非常感兴趣'
            ]
          },
          {
            type: 2,
            headline: '3.你觉得这些题目新颖吗？',
            value: [
              '很不新颖', '不新颖', '一般', '新颖', '非常新颖'
            ]
          },
          {
            type: 8,
            answerList: [],
            headline: '4.你认为这些题目属于哪个学科（可多选）',
            value: [
              ['语文', '道德与法治', { type: 'input', value: '其他（请说明）' }, '不清楚'],
              ['语文', '历史', '地理', { type: 'input', value: '其他（请说明）' }, '不清楚']
            ]
          },
          {
            type: 2,
            headline: '5.你觉得题目难度如何？',
            value: [
              '很容易', '比较容易', '一般', '比较难', '非常难'
            ]
          },
          {
            type: 7,
            headline: '6.你觉得这个任务还可以进行哪些修改，以便于你理解题目要求或作答？（例如，如何修改题目要求、额外提供哪些资料、以何种方式呈现资料等）'
          }
        ]
      ]
    }
  },
  methods: {
    initTheme() {
      const theme0 = ['examPhone', 'examChiliProblem', 'examEnergy']
      // const subject = 'exam' + sessionStorage.subjectName[0].toUpperCase() + sessionStorage.subjectName.substr(1)
      const subject = JSON.parse(sessionStorage.currentExamGroup).exam[sessionStorage.currentExamIndex - 1]
      if (theme0.indexOf(subject) > -1) {
        this.dataSource.find(item => {
          item.forEach(it => {
            if (it.type === 8) {
              it.value = it.value[0]
            }
          })
        })
      } else {
        this.dataSource.find(item => {
          item.forEach(it => {
            if (it.type === 8) {
              it.value = it.value[1]
            }
          })
        })
      }
    }
  },
  mounted() {
    this.initTheme()
  }
}
</script>
<style lang="less">
</style>
